import script from "./SobreNosotros.vue?vue&type=script&setup=true&lang=js"
export * from "./SobreNosotros.vue?vue&type=script&setup=true&lang=js"

import "./SobreNosotros.vue?vue&type=style&index=0&id=f5f348b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5f348b0"]])

export default __exports__